import { useContext } from "react";

import { TwoFactorAuthenticationContext } from "Contexts/TwoFactorAuthentication";

const UseTwoFactorAuthentication = () => {
  const { runTwoFactorAuthentication } = useContext(
    TwoFactorAuthenticationContext,
  );

  return {
    runTwoFactorAuthentication,
  };
};

export default UseTwoFactorAuthentication;
